import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  getQuestionsAndAnswers,
  selectAppraisal
} from "../../../store/selectors";
import useRadioAndSelectQuestionCompact from "../hooks/useRadioAndSelectQuestionCompact";
import DropdownQuestion from "../../../components/DropdownQuestion/DropdownQuestion";

interface AnswerObject {
  id: number;
  label: string;
}

interface RadioAndSelectQuestion {
  question: Question;
}

export const RadioAndSelectQuestionCompact = ({
  question
}: RadioAndSelectQuestion) => {
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { conditionalAnswersSubmitted } = useSelector(selectAppraisal);

  const {
    noDamage,
    handleChange,
    answersForSelect,
    answer,
    labelForSelect,
    groupName,
    questionString,
    noDamageLabel,
    showSelectLabel,
    showSelectValue,
    allAnswersSorted
  } = useRadioAndSelectQuestionCompact({ question });
  const [toggleSelect, setToggleSelect] = useState(
    (storedAnswer && storedAnswer[0] === showSelectValue) ||
      (storedAnswer && storedAnswer[0] !== noDamage)
      ? true
      : false
  );
  const isAnswerSubmitted = conditionalAnswersSubmitted.includes(question.id);
  const radioError = !storedAnswer && isAnswerSubmitted;
  const selectError =
    storedAnswer && storedAnswer[0] === showSelectValue && isAnswerSubmitted;
  const selectOnlyError =   (!storedAnswer ||  (storedAnswer && storedAnswer[0] === showSelectValue)) && isAnswerSubmitted;
  return (
    <>
      <p className="ch-width--12 ch-form__control-label ch-mb--2">
        {questionString}
      </p>
      {question.metadata?.inputComponent?.toLowerCase() === "RadioSelect".toLowerCase() ? (
        <>
          <div className="ch-form__group">
            {radioError && (
              <div className="ch-form__group ch-form__group--error ch-mb--0">
                <span className="ch-form__control-validation ch-mb--1">
                  Please choose an option
                </span>
              </div>
            )}

            <input
              id={`${groupName}-yes`}
              type="radio"
              name={`${groupName}NeedRepaired`}
              value={showSelectValue}
              className="ch-radio"
              checked={
                (answer && answer[0] === showSelectValue) ||
                (Boolean(answer) && Boolean(noDamage) && answer[0] !== noDamage)
              }
              onChange={({ target: { value } }) => {
                setToggleSelect(true);
                handleChange(parseInt(value));
              }}
            />
            <label
              htmlFor={`${groupName}-yes`}
              className="ch-radio__label ch-radio__label--primary"
            >
              {showSelectLabel}
            </label>

            <input
              id={`${groupName}-no`}
              type="radio"
              name={`${groupName}NeedRepaired`}
              value={noDamage}
              className="ch-radio"
              checked={
                Boolean(answer) && Boolean(noDamage) && answer[0] === noDamage
              }
              onChange={({ target: { value } }) => {
                setToggleSelect(false);
                handleChange(parseInt(value));
              }}
            />
            <label
              htmlFor={`${groupName}-no`}
              className="ch-radio__label ch-radio__label--primary ch-ml--2"
            >
              {noDamageLabel}
            </label>
          </div>
          {toggleSelect && (
            <div
              className={`ch-form__group ${
                selectError ? "ch-form__group--error" : ""
              }`}
            >
              <label
                htmlFor={`${groupName}Damaged`}
                className="ch-form__control-label"
              >
                {labelForSelect}
              </label>
              {selectError && (
                <span className="ch-form__control-validation">
                  Please choose an option
                </span>
              )}
              <select
                name={`${groupName}Damaged`}
                className="ch-form__control custom-dropdown ch-color--grey-6"
                onChange={({ target: { value } }) =>
                  handleChange(parseInt(value))
                }
                value={answer[0]}
              >
                <option value="">Select an option</option>
                {answersForSelect.map((answerObject: AnswerObject) => (
                  <option key={answerObject.id} value={answerObject.id}>
                    {answerObject.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </>
      ) : (
        <DropdownQuestion
          id={`${question.id}`}
          labelText=""
          name={`${question.id}`}
          defaultValue={storedAnswer}
          defaultOptionText="Select an option"
          onChange={(event) => handleChange(parseInt(event.target.value))}
          options={allAnswersSorted}
          validationMessage={selectOnlyError ? "Select an option" : null}
          noOptionValue={showSelectValue}
        />
      )}
    </>
  );
};
